import { throttle } from '@/libs/utils'

function resizeFont (el, options = {}) {
  const container = el.parentElement
  const maxFontSize = options.max || 100
  const minFontSize = options.min || 8
  let fontSize = maxFontSize

  el.style.whiteSpace = 'nowrap'
  el.style.display = 'inline-block'
  el.style.fontSize = fontSize + 'px'

  while (el.scrollWidth > container.clientWidth && fontSize > minFontSize) {
    fontSize--
    el.style.fontSize = fontSize + 'px'
  }
}

const AutoFitText = {
  install (Vue, options = {}) {
    Vue.directive('auto-fit-text', {
      bind (el, binding) {
        const opts = binding.value || options
        const debouncedResize = throttle(() => resizeFont(el, opts), 200)
        el.__autoFitResize__ = debouncedResize
        el.__autoFitOptions__ = opts

        window.addEventListener('resize', debouncedResize)
        setTimeout(() => resizeFont(el, opts), 0)
      },
      componentUpdated (el, binding) {
        const opts = binding.value || el.__autoFitOptions__ || options
        setTimeout(() => resizeFont(el, opts), 0)
      },
      unbind (el) {
        window.removeEventListener('resize', el.__autoFitResize__)
        delete el.__autoFitResize__
        delete el.__autoFitOptions__
      }
    })
  }
}

export default AutoFitText
